import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { updateQueryParams } from "@/scripts/common/util";

const form = document.querySelector(".filter-form");

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
  }
};

const handleFilter = (e) => {
  const url = updateQueryParams([[e.target.name, e.target.value]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  const url = updateQueryParams(false);
  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-form", "change", handleFilter);
    delegate(".filter-form", "form:clear", handleFilterClear);
  }
});
